import {randomString} from './string.utils';

export function removeQueryParam(url: string, param: string): string {
    const urlObj = new URL(url);
    urlObj.searchParams.delete(param);
    return urlObj.toString();
}

export function generateRandomQueryVals(url: string, ignore: string[] = []): string {
    const urlObj = new URL(url);

    urlObj.searchParams.forEach((_, key) => {
        if (ignore.includes(key)) return;
        urlObj.searchParams.set(key, randomString(32));
    });

    return urlObj.toString();
}
